import React, { useState } from "react";
import func from "../../../services/functions";
import { useAppContext } from "../../../AppContext";
import { useTranslation } from "react-i18next";
import PopOver from "../../global/PopOver";
import Select from "react-select";
import { Dialog } from "primereact/dialog";
import AddBankAccount from "../../Companies/BankAccounts/AddBankAccount";
import { compactSelect } from "../../../design/selectStyle";

const { formatNumber, countDecimals } = func;
const DemoSideMenu = ({ errors, ...props }) => {
  let { invoiceState, setInvoiceState, bankAccounts=[], disabled, history } =
    props;

    bankAccounts=[{label:"None",value:"none",id:null}].concat(bankAccounts)
  const { t } = useTranslation("translations");
  const vatTypeOptions = [
    { label: t("vat.none"), value: "" },
    { label: t("vat.type_1"), value: "TYPE_1" },
    { label: t("vat.type_2"), value: "TYPE_2" },
    { label: t("vat.tax_free"), value: "TAX_FREE" },
    { label: t("vat.margin_scheme"), value: "MARGIN_SCHEME" },
    { label: t("vat.export_of_goods"), value: "EXPORT_OF_GOODS" },
  ];
  const {
    user: [user],
    selectedCompany: [selectedCompany],
    company: [fullCompany],
    getCompany
  } = useAppContext();

  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );
  const [minIssueDate, setMinIssueDate] = React.useState("");
  const [bankAccShow, setbankaccShow] = React.useState(false);

  React.useEffect(() => {
    let today = new Date();
    if (invoiceState.paymentMethodType === "cash") {
      setInvoiceState((invoiceState) => ({
        ...invoiceState,
        dueDate: today,
      }));
    }
  }, [invoiceState.paymentMethodType]);


  const typeOfDiscountVatCategoryOptions = [
    { label: "0%", value: "0" },
    { label: "6%", value: "6" },
    { label: "10%", value: "10" },
    { label: "20%", value: "20" },
  ];


  const handleInvoiceDataChange = (e, label, val) => {
    let key = e ? e.target.name : label;
    let value = e ? e.target.value : val;
    if (key == "rate") {
      let count = countDecimals(value);
      if (count > 6) return;
    }

    setInvoiceState((invoiceState) => ({
      ...invoiceState,
      [key]: value,
    }));
  };

  const handleInvoiceChange = (value, key) => {
    const keys = key.split(".");

    switch (keys.length) {
      case 1:
        setInvoiceState((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: value,
        }));
        break;
      case 2:
        setInvoiceState((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: {
            ...invoiceState[keys[0]],
            [keys[1]]: value,
          },
        }));
        break;
      case 3:
        setInvoiceState((invoiceState) => ({
          ...invoiceState,
          [keys[0]]: {
            ...invoiceState[keys[0]],
            [keys[1]]: {
              ...invoiceState[keys[0]][keys[1]],
              [keys[2]]: value,
            },
          },
        }));
        break;
      default:
        return;
    }
  };

  const handleSelectedBankAccount = (account) => {
    setInvoiceState((invoiceState) => ({
      ...invoiceState,
      bankAccount: account,
    }));
  };

  React.useEffect(() => {
    let value = invoiceState.subSequenceDelivType;
    if (value && invoiceState?.issueDate) {
      let date = new Date(invoiceState?.issueDate);
      if (value === "BOUNDBOOK") {
        date = func.dateBeforeSomeDays(11, date);
      } else if (value === "SERVICE" || value === "TECHNICALERROR") {
        date = func.dateBeforeSomeDays(1, date);
      } else {
        date = func.getMinIssueDate();
      }
      setMinIssueDate(date);
    }
  }, []);

  const handleDiscountChange = (key, value) => {
    const discountValue = value;
    setInvoiceState((invoiceState) => ({
      ...invoiceState,
      discount: {
        ...invoiceState.discount,
        [key]: discountValue,
      },
    }));
  };




  const bankAccount = invoiceState?.bankAccount;


  return (
    <div className="d-flex flex-column mr-0 mr-md-3">
      <label className="field-label mt-1">
        {t("company.operatorCode")}
        <PopOver title={t("company.operatorCode")} />
      </label>

      <input
        type="text"
        name="operator"
        className="form-control form-control-sm"
        value={invoiceState?.opCode}
        readOnly={true}
      />

      <label className="field-label mt-1">
        {fullCompany?.companyAttributes?.find(
          (a) => a?.attribute?.param == "internalId"
        )?.value ?? t("home.internalId")}
        <PopOver title={t("hints.internalId")} />
      </label>
      {/* <a href="#" class="tip">Link<span>This is the CSS tooltip showing up when you mouse over the link</span></a> */}
      <input
        name="internalId"
        type="text"
        title="ID e sistemit te brendshem"
        className={`form-control form-control-sm tip`}
        disabled={disabled}
        value={invoiceState.internalId}
        onChange={handleInvoiceDataChange}
      />
      <label className="field-label mt-1">
        {t("invoice.nr")}
        <PopOver title={t("hints.invoiceNumber")} />
        <span className="text-danger" style={{fontSize:"11px"}}>
          {" "}
          {process.env.REACT_APP_ALLOW_INVOICE_NR === "true"
            ? "*"
            : t(["invoice.add"])}
        </span>
      </label>
      <input
        name="number"
        type="text"
        className={`form-control form-control-sm ${
          process.env.REACT_APP_ALLOW_INVOICE_NR === "true"
            ? "required"
            : "readonly"
        }`}
        disabled={process.env.REACT_APP_ALLOW_INVOICE_NR !== "true" || disabled}
        value={invoiceState.number}
        onChange={handleInvoiceDataChange}
      />

      <label className="field-label mt-1">
        {t("invoice.contractNo")}
        <PopOver title={t("hints.contractNo")} />
      </label>
      <input
        name="contract"
        type="text"
        className={`form-control form-control-sm`}
        disabled={disabled}
        value={invoiceState.contract}
        onChange={handleInvoiceDataChange}
      />

      <label htmlFor="discount" className="field-label mt-1">
        {t("invoice.discount")}

        <PopOver title={t("hints.invoiceDiscount")} />
      </label>
      <div className="input-group input-group-sm" style={{borderRadius: "4px", overflow: "hidden"}}>
        <input
          type={disabled ? "text" : "number"}
          step="0.01"
          min="0.01"
          id="discount"
          name="discount"
          className="form-control form-control-sm"
          style={{borderRight: "none"}}
          disabled={disabled}
          value={
            disabled
              ? invoiceState.discount
                ? formatNumber(invoiceState.discount?.value || null)
                : ""
              : invoiceState.discount?.value
          }
          onChange={(e) => handleDiscountChange("value", e.target.value)}
        />
        <div className="input-group-append dropup">
          <button
            className={
              "btn btn-sm dropdown-toggle" +
              (disabled ? " disabled" : "")
            }
            style={{border: "1px solid #ced4da", borderLeft: "none", borderRadius: 0, backgroundColor: "#f8f9fa", fontSize: "0.8rem"}}
            disabled={disabled}
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {invoiceState?.discount?.type =="Percentage"?"%":invoiceState?.currency}
          </button>
          <div className="dropdown-menu">
            <a
              className="dropdown-item"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleDiscountChange("type", "Percentage");
              }}
            >
              {t("invoice.percentage")}
            </a>
            <a
              className="dropdown-item"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleDiscountChange("type", "value");
              }}
            >
              {t("invoice.value")}
            </a>
          </div>
        </div>
      </div>
      <label htmlFor="discountVat" className="field-label">
        {t("invoice.discountVat")}
        <PopOver title={t("hints.discountVat")}  />
      </label>

      <Select
        styles={compactSelect}
        id="discountVat"
        name="discountVat"
        options={typeOfDiscountVatCategoryOptions}
        value={
          typeOfDiscountVatCategoryOptions.find(
            (dVat) => dVat.value === invoiceState.discount.vat
          ) || null
        }
        onChange={(e) => handleDiscountChange("vat", e.value)}
        isDisabled={disabled}
      />
      {invoiceState.discount.vat === "0" && (
        <div className="form-group">
          <label htmlFor="vatLabel" className="field-label">
            {t("item.vatLabel")}
            <span className="text-danger"> *</span>
            <PopOver title={t("hints.vatType")} />
          </label>

          <Select
            styles={compactSelect}
            type="text"
            id="vatLabel"
            name="vatLabel"
            options={vatTypeOptions}
            value={
              vatTypeOptions.find(
                (VatC) => VatC.value === invoiceState.discount.vatLabel
              ) || ""
            }
            onChange={(e) => handleDiscountChange("vatLabel", e.value)}
            isDisabled={disabled}
          />
        </div>
      )}
      <label
        htmlFor="bankAccount"
        className="field-label d-flex align-items-center mt-1"
      >
        {t("company.bankAccount")}
        <PopOver title={t("hints.bankAccount")} />
        <button onClick={()=>setbankaccShow(true)} className="btn btn-light bg-white shadow-sm btn-sm btn-custom ml-auto">
            {t("subscription.add")}
        </button>
      </label>

      <Dialog
          header={t("bankAccount.add")}
          visible={bankAccShow}
          onHide={() => setbankaccShow(false)}
          style={{ width: "30vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        >
          <AddBankAccount modal={true} setbankaccShow={setbankaccShow} onBankAdded={()=>{setbankaccShow(false);getCompany()}} />
        </Dialog>

      {disabled ? (
        <input
          className="form-control form-control-sm"
          width="30"
          value={
            bankAccount ? `${bankAccount.bankName} | ${bankAccount.iban}` : ""
          }
          disabled
        />
      ) : (
        <Select
          styles={compactSelect}
          options={
            bankAccounts
            ?.filter(
              (bankAccount) =>
                bankAccount.currency === invoiceState.currency &&
                bankAccount.active === true || bankAccount.value=="none"
            )
            .map((account) => ({
              label: account.value=="none"?"Select...": `${account.bankName} | ${account.iban}`,
              value:account.value=="none"?"":account.id,
            }))}
          value={{
            label: bankAccount 
              ? `${bankAccount.bankName} | ${bankAccount.iban}`
              : "Select",
            value: bankAccount ? bankAccount.id : "",
          }}
          isSearchable={true}
          onChange={(account) => {
            handleSelectedBankAccount(
              bankAccounts.find(
                (bankAccount) => bankAccount.id === account.value || account.value=="none"
              ) ?? null
            );
          }}
          name="bankAccount"
          id="bankAccount"
        />
      )}
    </div>
  );
};

export default DemoSideMenu;
